/* eslint-disable prettier/prettier */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    LabelList,
    Legend,
    ResponsiveContainer,
    Tooltip,
    YAxis
} from 'recharts';
import './graph.css';

// const data = [
//     {
//         name: 'Chittagong',
//         value: 77,
//     },
//     {
//         name: 'Dhaka',
//         value: 60,
//     },
//     {
//         name: 'Khulna',
//         value: 100,
//     },
//     {
//         name: 'Rajshahi',
//         value: 31,
//     },
//     {
//         name: 'Sylhet',
//         value: 67,
//     },
// ];

const colors2 = [
    // 'ea',
    '#d9692f',
    '#d55d2c',
    '#d05227',
    '#cc4625',
    '#c73a22',
    '#bf231a',
    '#ba1717',
    '#c2191c',
    '#b71f23',
    '#ac2429',
    '#a12730',
    '#962a36',
    '#8b2c3c',
    '#d9692f',
    '#d55d2c',
    '#d05227',
    '#cc4625',
    '#c73a22',
    '#bf231a',
    '#ba1717',
    '#c2191c',
    '#b71f23',
    '#ac2429',
    '#a12730',
    '#962a36',
    '#8b2c3c',
    '#d9692f',
    '#d55d2c',
    '#d05227',
    '#cc4625',
    '#c73a22',
    '#bf231a',
    '#ba1717',
    '#c2191c',
    '#b71f23',
    '#ac2429',
    '#a12730',
    '#962a36',
    '#8b2c3c',
    '#d9692f',
    '#d55d2c',
    '#d05227',
    '#cc4625',
    '#c73a22',
    '#bf231a',
    '#ba1717',
    '#c2191c',
    '#b71f23',
    '#ac2429',
    '#a12730',
    '#962a36',
    '#8b2c3c',
];

function CustomTooltip({ active, payload }) {
    if (active) {
        return (
            <div className="custom-tooltip">
                <h6>{payload[0].payload.name}</h6>
                <p>{payload[0].payload.value}%</p>
            </div>
        );
    }
    return null;
}

const renderCustomizedLabel = (props) => {
    const { x, y, width, value } = props;
    const radius = 10;
  
    return (
      <g>
        <text x={x + width / 2} y={y - radius} fill="#fff"  textAnchor="middle" dominantBaseline="middle">
          {value}%
        </text>
      </g>
    );
  };

  function percentCalculate(target, completed) {
    return Math.round((completed / target) * 100 || 0);
  }

function StrikeRateBreakdown({data}) {
    
    const newData = data?.map((x) => ({name: x.from, value: percentCalculate(x.target, x.completed)}))

    const [opacity, setOpacity] = React.useState({
        value: 1,
      });
      const handleMouseEnter = (o) => {
        const { value } = o;
        setOpacity({ ...opacity, [value]: 0.5 });
      };
      const handleMouseLeave = (o) => {
        const { value } = o;
        setOpacity({ ...opacity, [value]: 1 });
      };

    return (
        <div style={{height: '100%'}}>
            <ResponsiveContainer width="100%" height={235}>
                <BarChart data={newData} 
                      margin={{
                        top: 30,
                        right: 20,
                        left: 10,
                        bottom: 50,
                      }}>
                     <CartesianGrid stroke="#E2A2A1" strokeWidth={0.5} />
                    <Tooltip
                        content={<CustomTooltip />}
                        cursor={{ fill: '#ffe8642e' }}
                        wrapperStyle={{ outline: "none" }}
                    />
                    <Legend
                        iconSize={14}
                        wrapperStyle={{ fontSize: '14px', paddingTop: '10px', color: '#fff' }}
                        layout="horizontal"
                        verticalAlign = "bottom"
                        payload={newData.map((item, index) => ({
                            id: item.name,
                            type: 'square',
                            value: `${item.name}`,
                            color: colors2[index % colors2.length],
                        }))}
                        // eslint-disable-next-line react/no-unstable-nested-components
                        formatter={(value) => <span style={{ color: '#fff' }}>{value}</span>}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    />
                    <YAxis
                        domain={[0, 100]}
                        tick={{ fill: '#fff' }}
                        tickFormatter={(number) => `${number}%`}
                        tickCount={3}
                        axisLine={{stroke:"#E2A2A1", strokeWidth:0.5}}
                    />
                    <Bar
                        dataKey="value"
                        radius={[25, 25, 0, 0]}
                        fillOpacity={opacity.value}
                        fill="#8884d8">
                        <LabelList dataKey="value" position="insideTop" angle="45" content={renderCustomizedLabel}/>
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={colors2[index % 20]} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export default StrikeRateBreakdown;
